import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import { FaRupeeSign } from "react-icons/fa";
import { FiArrowRight, FiCalendar, FiXCircle } from "react-icons/fi";
import { GoBriefcase } from "react-icons/go";
import { IoCalendarOutline } from "react-icons/io5";
import { MdNavigateBefore, MdNavigateNext } from "react-icons/md";
import { withRouter } from "react-router";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import { io } from "socket.io-client";
import Swal from "sweetalert2";
import MyYuukke from "../../api/MyYuukke";
import ProfileService from "../../api/ProfileService";
import { SOCKET_URL } from "../../chatPanel/src/config/config.js";
import RazorPay from "../../components/RazorPay2.jsx";
import { API_URL, REACT_APP_SITE_KEY } from "../../config/app-config";
import faceBook from "../../images/SocialMediaGif/Facebook.png";
import instagram from "../../images/SocialMediaGif/instagram.png";
import personalWebsite from "../../images/SocialMediaGif/internet.png";
import linkedIn from "../../images/SocialMediaGif/Linkedin.png";
import youtube from "../../images/SocialMediaGif/youtube.png";
import yuukke from "../../images/SocialMediaGif/yuukke-white.png";
import dummyimage from "../../img/default_avatar.jpg";
import woman from "../../img/woman.png";
import { generateMonthDates, generateTimeSlots } from "../../utils";
import AssessmentForm from "../Calender/ProfileCalendar/AssessmentForm.jsx";
import ServiceUserForm from "../Calender/ProfileCalendar/ServiceUserForm.jsx";
import VcardChatBox from "../Calender/ProfileCalendar/VcardChatBox.jsx";
import CalendarTabs from "../Forms/CalendarTabs.jsx";

import { CHAT_URL } from "../../config/app-config.js";
import ServicePageHelmet from "./ServicePageHelmet.jsx";
import OldMinimalBookingPage from "./OldMinimalBookingPage.jsx";
import AllReviewsModal from "./AllReviewsModal.jsx";
import QuickBookServiceCard from "./QuickBookServiceCard.jsx";
import DefaultThemeProfile from "./DefaultThemeProfile.jsx";

// Theme Imports
import ServiceCardThemeV2 from "./ServiceCardThemeV2.jsx";
import ServiceCardThemeV3 from "./ServicecardthemeV3.jsx";
import ServiceCardThemeV4 from "./ServiceCardThemeV4.jsx";
import ServiceCardThemeV5 from "./ServiceCardThemeV5.jsx";
import ServiceCardThemeV6 from "./ServiceCardThemeV6.jsx";
import ServiceCardThemeV7 from "./ServiceCardThemeV7.jsx";
import ServiceCardThemeV8 from "./ServiceCardThemeV8.jsx";
import ServiceCardThemeV9 from "./ServiceCardThemeV9.jsx";
import ServiceCardThemeV10 from "./ServiceCardThemeV10.jsx";
import ServiceCardThemeV11 from "./ServiceCardThemeV11.jsx";
import ServiceCardThemeV12 from "./ServiceCardThemeV12.jsx";
import ServiceCardThemeV13 from "./ServiceCardThemeV13.jsx";
import ServiceCardThemeV14 from "./ServiceCardThemeV14.jsx";
import ServiceCardThemeV15 from "./ServiceCardThemeV15.jsx";
import ServiceCardThemeV16 from "./ServiceCardThemeV16.jsx";
import ServiceCardThemeV17 from "./ServiceCardThemeV17.jsx";
import ServiceCardThemeV18 from "./ServiceCardThemeV18.jsx";

// ─── AI Theme Suggestion Engine ──────────────────────────────────────────────
// Automatically maps categories to the most suitable visual aesthetic
const getThemeSuggestions = (categories) => {
  if (!categories || categories.length === 0) return [1]; 

  // Check for either categoryId (new JSON) or primaryId (old structure)
  const primaryCat = categories[0];
  const catId = primaryCat?.categoryId || primaryCat?.primaryId;

  const suggestions = {
    1: [11, 4, 5],       // Lifestyle -> Creative Atelier (11), Sanctuary (4), Sunrise (5)
    2: [17, 18, 12],     // Financial/Legal -> Strategy Brief (17), Systems (18), Map-room (12)
    3: [18, 17, 12, 15], // Consulting -> Systems (18), Strategy (17), Map-room (12), Dossier (15)
    4: [10, 13, 15, 14], // Education -> Conversations (10), Study Desk (13), Dossier (15), Language (14)
    5: [11, 16, 17],     // Marketing -> Creative Atelier (11), Operator (16), Strategy Brief (17)
    6: [9, 10, 4]        // Well-being -> Movement Lab (9), Conversations (10), Sanctuary (4)
  };

  return suggestions[catId] || [1]; // Fallback to V2 (id: 1) if unknown
};

// ─── Shared bits pulled out of the render tree ───────────────────────────────
const BookingOverlays = ({ state, auditUUID, updatePaymentStatus, onAssessmentComplete }) => (
  <>
    {state.paymentPage && (
      <RazorPay
        email={state.email}
        name={state.name}
        uId={state.serviceProviderUserId}
        userId={null}
        contactNumber={state.phoneNumber}
        subscriptionId={state.subscribeId}
        amount={state.serviceAmount}
        type={"slot_booking"}
        updatePaymentStatus={updatePaymentStatus}
        serviceId={state.serviceId}
        auditUUID={auditUUID}
      />
    )}
    {state.assessmentForm && (
      // Forced into its own fixed, ultra-high-stacking wrapper. Each themed
      // booking modal (ServiceCardThemeV3/V4/V5/etc.) sets its own overlay
      // z-index independently, and AssessmentForm was rendering underneath
      // whichever one happened to be open because AssessmentForm's own
      // internal z-index isn't guaranteed to beat every theme's value. This
      // wrapper guarantees the assessment form always paints above every
      // themed booking modal, regardless of that theme's own z-index.
      <div style={{ position: "fixed"}}>
        <AssessmentForm
          questions={state.assessmentQuestions}
          updateAssessment={onAssessmentComplete}
        />
      </div>
    )}
  </>
);

// ─── Purchase-validation blocked screen ──────────────────────────────────────
// Hard gate: when the provider's purchase/subscription has expired, this
// is the ONLY thing rendered in place of the booking page — no services,
// no calendar, nothing else. Just the message telling the visitor to ask
// the provider to resubscribe.
const PurchaseInvalidNotice = () => (
  <div
    style={{
      minHeight: "60vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: "2rem",
    }}
  >
    <IoCalendarOutline style={{ fontSize: "3rem", marginBottom: "1rem", opacity: 0.6 }} />
    <h4>Booking Unavailable</h4>
    <p>This service provider's subscription has expired. Please ask them to resubscribe to enable bookings.</p>
  </div>
);

// ─── Theme registry ───────────────────────────────────────────────────────────
const THEME_COMPONENTS = {
  1: ServiceCardThemeV2,
  3: ServiceCardThemeV3,
  4: ServiceCardThemeV4,
  5: ServiceCardThemeV5,
  6: ServiceCardThemeV6,
  7: ServiceCardThemeV7,
  8: ServiceCardThemeV8,
  9: ServiceCardThemeV9,
  10: ServiceCardThemeV10,
  11: ServiceCardThemeV11,
  12: ServiceCardThemeV12,
  13: ServiceCardThemeV13,
  14: ServiceCardThemeV14,
  15: ServiceCardThemeV15,
  16: ServiceCardThemeV16,
  17: ServiceCardThemeV17,
  18: ServiceCardThemeV18,
};

const THEME_CARD_WITHOUT_PREVIEW_PROP = new Set([1]);
const THEME_CARD_KEYS = Object.keys(THEME_COMPONENTS);

const PURCHASE_INVALID_MESSAGE =
  "This service provider's subscription has expired. Please ask them to resubscribe to enable bookings.";

const CalendarVcard = (props) => {
  const [state, setState] = useState({
    bookingPage: false,
    slots: [],
    availableSlot: [],
    activeIndexData: null,
    selectedSlot: null,
    slotActiveIndex: null,
    part: null,
    loader: true,
    eventDetails: null,
    userSlots: [],
    currentServiceSlots: [],
    userDetails: null,
    bookingCount: null,
    detailsPage: false,
    name: "",
    email: "",
    phoneNumber: "",
    description: "",
    bio: "",
    type: "",
    singleDate: new Date(),
    bookedSlot: [],
    paymentPage: false,
    paymentId: null,
    dayId: null,
    serviceList: [],
    serviceLists: [],
    serviceId: null,
    serviceAmount: 0,
    minutes: 0,
    appointmentValue: "",
    assessmentForm: false,
    assessmentQuestions: [],
    assessmentNeed: false,
    assessmentAnswer: [],
    socialMedia: [],
    serviceDetails: null,
    language: [],
    clarityService: null,
    chatBoxOpen: false,
    serviceProviderUserId: null,
    serviceChatDetails: null,
    openServiceChatForm: false,
    themeCard: 0,
    backThemCard: true,
    reviewList: [],
    recommendList: [],
    exitUser: null,
    userUpcomingMeting: [],
    customTheme: false,
    packageDays: "",
    timeSlots: "",
    bookingSuccess: false,
    bookingMode: "self",
    expertNote: "",
    category: [],
    hasMultiplePrimaryIds: false,
    resourceList: [],
    resourceListCount: 0,
    // Purchase validation gate. Defaults to true (optimistic) so the UI
    // doesn't flash a "blocked" screen before the API response arrives.
    // Set to the real value once getSlotDetails resolves.
    purchaseValid: true,
  });

  const [showServiceDropdown, setShowServiceDropdown] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const socket = useRef();
  const [scrollPosition, setScrollPosition] = useState(0);
  const optionsMenu = useRef();
  const recaptcha = useRef();
  const [isHovered, setIsHovered] = useState(false);
  const [serviceError, setServiceError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [auditUUID, setAuditUUID] = useState(null);
  const [calYear, setCalYear] = React.useState(() => new Date().getFullYear());
  const [calMonth, setCalMonth] = React.useState(() => new Date().getMonth());
  const [maxScroll, setMaxScroll] = useState(0);
  const [cardWidth, setCardWidth] = useState(300);
  const listRef = useRef(null);
  const [reviewsModalOpen, setReviewsModalOpen] = useState(false);

  const handleOpenReviews = () => setReviewsModalOpen(true);

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }

  const slug = props.slug || props.match?.params?.slug;
  const isMobile = window.screen.width < 768;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const serviceId =
    props.serviceId ||
    props.match?.params?.serviceId ||
    queryParams.get("serviceId");

  // ─── Effects ──────────────────────────────────────────────────────────────

  useEffect(() => {
    if (props?.isPreview) {
      updateData(props.data);
      return;
    }
    var main = document.getElementById("base");
    if (main) {
      main.style.backgroundImage = `linear-gradient(205deg, #000940 0%, #a00030 100%)`;
    }
    if (!slug) {
      invalid();
      return;
    }
    getSlotDetails(slug);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.data, slug]);

  useEffect(() => {
    if (!serviceId) return;
    if (String(state.serviceId) !== String(serviceId)) return;
    if (state.selectedSlot) return;
    if (!state.availableSlot?.length) return;

    const firstAvailable = state.availableSlot.find(
      (s) => s.slotAvailable !== false,
    );
    if (!firstAvailable) return;

    const idx = state.availableSlot.indexOf(firstAvailable);

    setState((prev) => ({
      ...prev,
      selectedSlot: firstAvailable,
      slotActiveIndex: idx,
    }));

    setTimeout(() => {
      document
        .getElementById("booking-panel-section")
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
  }, [serviceId, state.serviceId, state.availableSlot, state.selectedSlot]);

  useEffect(() => {
    if (state.serviceChatDetails && state.serviceChatDetails?.id) {
      let userInfo = {
        uId: state.serviceChatDetails?.id,
        dName: state.serviceChatDetails?.name,
        profile_uuid: "",
        email: state.serviceChatDetails?.email,
        active: true,
        userType: "guest",
      };
      socket.current.emit("serviceUser", userInfo);
    }
  }, [state.serviceChatDetails]);

  // ─── Helpers ──────────────────────────────────────────────────────────────

  const updateState = (key, value) => setState((prev) => ({ ...prev, [key]: value }));

  const invalid = () => {
    setState((previous) => ({
      ...previous,
      eventDetails: null,
      loader: false,
    }));
    toast.error("Invalid link !, please check link");
  };

  const generateUUID = () =>
    ([1e7] + -1e3 + -4e3 + -8e3 + -1e3).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16),
    );

  const primaryColor = () => state.eventDetails?.primaryColor || "";
  const secondaryColor = () => state.eventDetails?.secondaryColor || "";
  const headingColor = () => state.eventDetails?.headingColor || "";
  const secondaryHeadingColor = () => state.eventDetails?.subHeadingColor || "";
  const serviceType = state.selectedService === "clarity" ? "Demo" : "Service";

  const toCamelCase = (str) => {
    if (!str || typeof str !== "string") return "";
    return str
      .toLowerCase()
      .split(" ")
      .map((word, index) =>
        index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1),
      )
      .join(" ");
  };

  const safeParse = (value) => {
    try {
      if (!value) return [];
      const parsed = JSON.parse(value);
      return typeof parsed === "string" ? JSON.parse(parsed) : parsed;
    } catch (e) {
      return [];
    }
  };

  const packageDays = useMemo(() => safeParse(state?.packageDays), [state?.packageDays]);
  const timeSlots = useMemo(() => safeParse(state?.timeSlots) || [], [state?.timeSlots]);

  const getSliderText = (data) => {
    let list = [];
    if (data?.sliderTextOne) list.push(data.sliderTextOne);
    if (data?.sliderTextTwo) list.push(data.sliderTextTwo);
    if (list.length === 0) list.push("Book your appointment now");
    return list;
  };

  const parseTimeToMinutes = (timeStr) => {
    if (!timeStr) return 0;
    if (/^\d{1,2}:\d{2}$/.test(timeStr.trim())) {
      const [h, m] = timeStr.trim().split(":").map(Number);
      return h * 60 + m;
    }
    const match = timeStr.trim().match(/^(\d{1,2}):(\d{2})\s*(am|pm)$/i);
    if (match) {
      let h = parseInt(match[1]);
      const m = parseInt(match[2]);
      const period = match[3].toLowerCase();
      if (period === "pm" && h !== 12) h += 12;
      if (period === "am" && h === 12) h = 0;
      return h * 60 + m;
    }
    return 0;
  };

  const getAvailableDateSlot = (date, availableSlot, bookedSlot) => {
    if (!bookedSlot?.length) {
      return availableSlot.map((item) => ({ ...item, slotAvailable: true }));
    }
    let slots = availableSlot;
    if (date === moment(new Date()).format("YYYY/MM/DD")) {
      const now = new Date();
      slots = availableSlot.filter((slot) => {
        const [h, m] = slot.from.split(":").map(Number);
        const slotTime = new Date();
        slotTime.setHours(h, m, 0, 0);
        return slotTime >= now;
      });
    }
    const bookedRanges = bookedSlot
      .filter((item) => date === moment(item.startTime).format("YYYY/MM/DD"))
      .map((item) => {
        const ts = JSON.parse(item.timeSlot);
        return {
          from: parseTimeToMinutes(ts[0].from),
          to: parseTimeToMinutes(ts[0].to),
        };
      });
    return slots.map((item) => {
      const slotFrom = parseTimeToMinutes(item.from);
      const slotTo = parseTimeToMinutes(item.to);
      const adjustedTo = slotTo === 0 ? 1440 : slotTo;
      const isBlocked = bookedRanges.some((booked) => {
        const bookedTo = booked.to === 0 ? 1440 : booked.to;
        return slotFrom < bookedTo && adjustedTo > booked.from;
      });
      return { ...item, slotAvailable: !isBlocked };
    });
  };

  const resizeSlotsForService = (rawSlots, duration) => {
    return rawSlots.map((daySlot) => {
      if (!daySlot.timeSlots || daySlot.timeSlots.length === 0) return daySlot;
      const dayStart = daySlot.timeSlots[0].from;
      const lastSlot = daySlot.timeSlots[daySlot.timeSlots.length - 1];
      let dayEnd = lastSlot.to;
      if (dayEnd === "00:00" || dayEnd === "0:00") dayEnd = "24:00";
      return {
        ...daySlot,
        timeSlots: generateTimeSlots(dayStart, dayEnd, duration),
      };
    });
  };

  // ─── API ──────────────────────────────────────────────────────────────────

  const getSlotDetails = (userSlug) => {
    MyYuukke.getSlotDetailsByIdV3(userSlug)
      .then((response) => {
        let result = response.data.data.eventData;
        result.eventName = response.data.data.eventName;

        if (result) {
          const userSlots = response.data.data.slots;
          const serviceList = response.data.data.service || [];
          const category = response.data.data.category || [];
          const resourceList = response.data.data.resource || [];

          // Accommodate both old (primaryId) and new (categoryId) structures
          const uniquePrimaryIds = new Set(
            category.map((item) => item.categoryId || item.primaryId),
          );
          const hasMultiplePrimaryIds = uniquePrimaryIds.size > 1;

          const updateTimes = userSlots.map((item) => {
            if (item.timeSlots.length === 1) {
              return {
                ...item,
                timeSlots: generateTimeSlots(
                  item.timeSlots[0].from,
                  item.timeSlots[0].to,
                  response.data.data.meetingDuration,
                ),
              };
            }
            return item;
          });
          const hasSingleSlot = userSlots.some((item) => item.timeSlots.length === 1);
          const getDayList = userSlots.reduce((result, item) => {
            if (item.timeSlots.length > 0) result.push(item.day);
            return result;
          }, []);
          const monthDates = generateMonthDates(getDayList);
          const indexOfDate = monthDates.findIndex((item) => item.available === true);
          let activeIndexData = monthDates[indexOfDate];
          activeIndexData.index = indexOfDate;
          const getDaySlots = userSlots.find(
            (item) => item.day.toLowerCase() === activeIndexData.day.toLowerCase(),
          );

          // Service provider's own purchase validation flag.
          // API field is isPurchaceNotExpired.
          // isPurchaceNotExpired === false -> provider's subscription has
          //   expired -> block booking entirely, show message instead.
          // Anything else (true, undefined, null) -> allow booking flow.
          const purchaseValid = response.data.data.isPurchaceNotExpired !== false;

          const obj = {
            result: result,
            response: response.data.data,
            monthDates: monthDates,
            activeIndexData: activeIndexData,
            serviceLists: serviceList,
            id: getDaySlots ? getDaySlots.id : null,
            userSlots: hasSingleSlot ? updateTimes : userSlots,
            category,
            hasMultiplePrimaryIds,
            purchaseValid,
          };
          updateData(obj);
          setState((prevState) => ({
            ...prevState,
            serviceLists: serviceList,
            resourceList: resourceList,
            category,
            hasMultiplePrimaryIds,
          }));
        } else {
          toast.error("Slot not present, please check url");
          updateState("loader", false);
        }
      })
      .catch((e) => {
        toast.error("Slot not present, please check url");
        updateState("loader", false);
        console.log("Error", e);
      });
  };

  const updateSlotsData = (userSlots) => {
    const getDayList = userSlots.reduce((result, item) => {
      if (item.timeSlots.length > 0) result.push(item.day);
      return result;
    }, []);
    const monthDates = generateMonthDates(getDayList);
    const indexOfDate = monthDates.findIndex((item) => item.available === true);
    let activeIndexData = monthDates[indexOfDate];
    activeIndexData.index = indexOfDate;
    const getDaySlots = userSlots.find(
      (item) => item.day.toLowerCase() === activeIndexData.day.toLowerCase(),
    );
    setState((prevState) => ({
      ...prevState,
      slots: monthDates,
      activeIndexData,
      dayId: getDaySlots ? getDaySlots.id : null,
      userSlots,
    }));
  };

  const updateData = (obj) => {
    const bookedSlotCopy = JSON.parse(JSON.stringify(obj.response.bookedSlot));
    let socialMedia = [];
    if (obj.response.userDetails.faceBook)
      socialMedia.push({ link: obj.response.userDetails.faceBook, icon: faceBook });
    if (obj.response.userDetails.instagram)
      socialMedia.push({ link: obj.response.userDetails.instagram, icon: instagram });
    if (obj.response.userDetails.linkedIn)
      socialMedia.push({ link: obj.response.userDetails.linkedIn, icon: linkedIn });
    if (obj.response.userDetails.youtube)
      socialMedia.push({ link: obj.response.userDetails.youtube, icon: youtube });

    // ─── Theme Auto-Suggestion Logic ───
    // uiTheme has three possible states from the backend: a real theme id
    // (1, 3, 4, ...), explicitly 0 (provider has chosen the Default theme),
    // or null/undefined (never set — brand-new provider). The suggestion
    // engine should only ever kick in for that last case. It previously
    // also matched `currentTheme === 0`, which meant an explicit "use the
    // Default theme" choice got silently overwritten the moment a category
    // was set — getThemeSuggestions() falls back to [1] (V2) for any
    // unmapped category, so uiTheme=0 would render V2 instead of
    // DefaultThemeProfile.
    const isThemeUnset =
      obj.response.eventData?.uiTheme === null ||
      obj.response.eventData?.uiTheme === undefined;

    let currentTheme = obj.response.eventData?.uiTheme ?? 0;

    if (isThemeUnset && obj.category?.length > 0 && !obj.hasMultiplePrimaryIds) {
      const suggestedThemes = getThemeSuggestions(obj.category);
      currentTheme = suggestedThemes[0]; // Apply top recommendation
    }

    if (obj.response.userDetails.personalWebsite && currentTheme !== 1)
      socialMedia.push({ link: obj.response.userDetails.personalWebsite, icon: personalWebsite });

    const findClarityService =
      obj.response?.service && obj.response.service.find((item) => item.type === "clarity");

    setState((previous) => ({
      ...previous,
      socialMedia: socialMedia,
      eventDetails: obj.result,
      loader: false,
      userSlots: obj.response.slots,
      userDetails: obj.response.userDetails,
      slots: obj.monthDates,
      bookingCount: obj.response.bookingCount,
      activeIndexData: obj.activeIndexData,
      bookedSlot: bookedSlotCopy,
      dayId: obj.id,
      serviceList: obj.response?.service || [],
      language: obj.response.language ?? [],
      clarityService: findClarityService,
      serviceProvider: {
        userId: obj.response.userDetails.userId,
        userName: obj.response.userDetails.userName,
      },
      serviceProviderUserId: obj.response.userDetails.userId,
      reviewList: obj.response.reviewList,
      recommendList: obj.response.recommendList,
      themeCard: currentTheme, // Applied here
      exitUser: localStorage.getItem("EXIT-USER-EMAIL") ?? null,
      sliderText: getSliderText(obj.response.eventData),
      customTheme: obj.response.eventData.customTheme ?? false,
      // obj.purchaseValid is undefined when called from the isPreview path
      // (props.data doesn't carry isPurchaceNotExpired) — default to true
      // there so preview mode is never blocked by a field it doesn't have.
      purchaseValid: obj.purchaseValid ?? true,
    }));

    if (props.isPreview) return;
    socket.current = io(SOCKET_URL, {});
    let serviceChatEmail = localStorage.getItem("SERVICE-EMAIL");
    if (serviceChatEmail && obj.response.userDetails.userId) {
      MyYuukke.getServiceChatDetails({
        email: serviceChatEmail,
        userId: obj.response.userDetails.userId,
      })
        .then((response) => {
          if (response.data.message !== "fail")
            updateState("serviceChatDetails", response.data.data);
        })
        .catch((e) => console.log("e", e));
    }
    if (obj?.result?.fontFamily) {
      document.documentElement.style.setProperty("--app-font", obj?.result?.fontFamily);
    }
    if (localStorage.getItem("EXIT-USER-EMAIL") && obj.response.eventData.id) {
      MyYuukke.getUserSlotsByEmail({
        email: localStorage.getItem("EXIT-USER-EMAIL"),
        calendarId: obj.response.eventData.id,
      })
        .then((response) => {
          if (response.data.message !== "fail")
            updateState("userUpcomingMeting", response.data.data);
        })
        .catch((e) => console.log("e", e));
    }
  };

  const selectService = (data, serviceSelectOption) => {
    if (!state.purchaseValid) {
      toast.error(PURCHASE_INVALID_MESSAGE);
      return;
    }
    const rawSlots = data.slots?.length ? data.slots : state.userSlots;
    const resizedSlots = resizeSlotsForService(rawSlots, data.duration);
    updateSlotsData(resizedSlots);
    const findSlots = resizedSlots.find(
      (item) => item.day === state.activeIndexData.day.toUpperCase(),
    );
    const bookedSlotCopy = JSON.parse(JSON.stringify(state.bookedSlot));
    const list = getAvailableDateSlot(
      state.activeIndexData.value,
      findSlots?.timeSlots ?? [],
      bookedSlotCopy,
    );
    setState((previous) => ({
      ...previous,
      bookingPage: state.themeCard === 1 ? false : true,
      serviceAmount: data.amount,
      serviceId: data.id,
      minutes: data.duration,
      availableSlot: list ?? [],
      appointmentValue: data.appointmentValue,
      assessmentNeed: data.assessmentNeed,
      assessmentQuestions: data.assessmentQuestions ?? [],
      assessmentAnswer: [],
      assessmentForm: false,
      serviceDetails: data,
      type: serviceType,
      backThemCard: THEME_CARD_KEYS.includes(String(state.themeCard)),
      packageDays: data?.packageDays,
      timeSlots: data?.timeSlots,
      selectedSlot: null,
      slotActiveIndex: null,
      detailsPage: false,
      name: "",
      email: "",
      phoneNumber: "",
      description: "",
      currentServiceSlots: resizedSlots,
      bookingMode: "self",
      expertNote: "",
    }));
    setShowServiceDropdown(serviceSelectOption === "clarity");
  };

  const viewAvailableSlot = (index, data, available) => {
    if (!available) return;
    const sourceSlots = state.currentServiceSlots?.length
      ? state.currentServiceSlots
      : state.userSlots;
    const findSlots = sourceSlots.find(
      (item) => item.day === data.day.toUpperCase(),
    );
    if (!findSlots) return;
    const bookedSlotCopy = JSON.parse(JSON.stringify(state.bookedSlot));
    const list = getAvailableDateSlot(
      data.value,
      findSlots.timeSlots,
      bookedSlotCopy,
    );
    data.index = index;
    setState((previous) => ({
      ...previous,
      availableSlot: list ?? findSlots.timeSlots,
      activeIndexData: data,
      slotActiveIndex: null,
      selectedSlot: null,
      dayId: findSlots?.id,
    }));
  };

  // ─── Booking flow ─────────────────────────────────────────────────────────

  const uploadDetails = (e) => {
    e.preventDefault();

    if (!state.purchaseValid) {
      toast.error(PURCHASE_INVALID_MESSAGE);
      return;
    }

    const uuid = generateUUID();
    setAuditUUID(uuid);

    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    if (!state.name || !state.phoneNumber)
      return toast.warning("Fill all required fields");

    if (state.bookingMode === "expert") {
      const expertBookingData = {
        email: state.email,
        clientName: state.name,
        userName: state.name,
        mobileNo: state.phoneNumber,
        bio: state.description,
        id: state.eventDetails.id,
        type: state.type || "Service",
        serviceId: state.serviceId,
        userId: state.userDetails.userId,
        senderName: state.userDetails.userName,
        senderId: state.userDetails.userId,
        receiverList: [state.userDetails.userId],
        serviceName: state.serviceDetails?.serviceName ?? "Demo Service",
        amount: state.serviceAmount,
        baseUrl: window.location.origin,
        expertNote: state.expertNote,
        bookingType: "expert",
        isFreeBooking: !state.serviceAmount || state.serviceAmount === 0,
        ...(state.assessmentAnswer.length > 0 && {
          selfAssessment: state.assessmentAnswer,
        }),
        auditUUID: uuid,
        timeZone: timeZone,
      };

      MyYuukke.bookAudit(expertBookingData)
        .then(() => {
          if (!state.serviceAmount) {
            createFreePayment(uuid);
          } else {
            updateState("paymentPage", true);
          }
        })
        .catch((err) => {
          console.error("Expert booking error:", err);
          toast.error("Something went wrong. Please try again.");
        });

      return;
    }

    const combinedDateTime = `${state.activeIndexData.value} ${state.selectedSlot.from}`;
    const startDate = moment(combinedDateTime).format("YYYY-MM-DDTHH:mm:ss.SSSZ");
    const endDate = moment(combinedDateTime)
      .add(state.minutes || 30, "minutes")
      .format("YYYY-MM-DDTHH:mm:ss.SSSZ");

    const slot = [{ from: state.selectedSlot.from, to: state.selectedSlot.to }];

    const bookingData = {
      email: state.email,
      userName: state.name,
      mobileNo: state.phoneNumber,
      bio: state.description,
      timeSlot: slot,
      dateSlot: [state.activeIndexData.value],
      id: state.eventDetails.id,
      startTime: startDate,
      endTime: endDate,
      type: state.type || "Service",
      dayId: state.dayId,
      serviceId: state.serviceId,
      userId: state.userDetails.userId,
      userName: state.userDetails.userName,
      senderName: state.userDetails.userName,
      senderId: state.userDetails.userId,
      receiverList: [state.userDetails.userId],
      meetingInApplication: state.eventDetails.meetingInApplication,
      meetingUrl: state.eventDetails.meetingUrl,
      chatUrl: CHAT_URL,
      workSpaceType: state.eventDetails.workSpaceType,
      serviceName: state.serviceDetails?.serviceName ?? "Demo Service",
      amount: state.serviceAmount,
      providerContact: state.phoneNumber,
      url: state.eventDetails.meetingUrl,
      formatTime: moment(startDate).locale("en").format("MMMM Do YYYY, h:mm:ss a"),
      clientName: state.name,
      baseUrl: window.location.origin,
      bookingType: "self",
      isFreeBooking: !state.serviceAmount || state.serviceAmount === 0,
      ...(state.assessmentAnswer.length > 0 && {
        selfAssessment: state.assessmentAnswer,
      }),
      auditUUID: uuid,
      timeZone: timeZone,
    };

    MyYuukke.bookAudit(bookingData)
      .then(() => {
        if (!state.serviceAmount) {
          createFreePayment(uuid);
        } else {
          updateState("paymentPage", true);
        }
      })
      .catch(console.error);
  };

const createFreePayment = async (uuid) => {
  if (!state.purchaseValid) {
    toast.error(PURCHASE_INVALID_MESSAGE);
    return;
  }
  try {
    const body = {
      userId: state.userDetails.userId,
      amount: 0,
      status: "success",
      type: "slot_booking",
      serviceId: state.serviceId,
      email: state.email,
      auditUUID: uuid,
    };
    const res = await ProfileService.createPaymentHistory(body);
    if (res?.data?.status === 1) {
      updateState("paymentPage", false);
      updateState("bookingSuccess", true); // FIX 2: tell the theme modal it can close now
      await Swal.fire({
        icon: "success",
        title: "Thank you for scheduling your appointment!",
        text: "You will receive notifications shortly.",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
      window.location.href = "https://yuukke.com/";
    } else {
      toast.error("Free booking failed. Try again.");
    }
  } catch (err) {
    console.error("FREE PAYMENT ERROR:", err);
    toast.error("Something went wrong. Please try again.");
  }
};

  const confirmDetails = () => {
    if (!state.purchaseValid) {
      toast.error(PURCHASE_INVALID_MESSAGE);
      return;
    }
    if (isSubmitting) return;
    if (
      state.serviceDetails?.type === "clarity" &&
      (state.selectedService === null || state.selectedService === "")
    ) {
      toast.warning("Select service name");
      setServiceError(true);
      return;
    }
    setServiceError(false);
    if (state.bookingMode === "self" && !state.selectedSlot) {
      toast.warning("Please select a time slot");
      return;
    }
    if (state.bookingMode === "expert" && !state.expertNote?.trim()) {
      toast.warning("Please share your availability preference");
      return;
    }
    if (state.assessmentNeed && state.assessmentQuestions?.length > 0) {
      updateState("assessmentForm", true);
    } else {
      updateState("detailsPage", true);
    }
  };

const updatePaymentStatus = (status, id) => {
  if (status === "dismiss") {
    Swal.fire({
      icon: "error",
      title: "Payment Failed!",
      text: "If your amount is debited, contact support.",
    }).then(() => setState((prev) => ({ ...prev, paymentPage: false })));
    return;
  }
  if (status === "success") {
    setState((prev) => ({
      ...prev,
      paymentPage: false,
      paymentId: id,
      bookingSuccess: true, // FIX 2: keeps behavior consistent with the free flow
    }));
    Swal.fire({
      icon: "success",
      title: "Thank you for scheduling your appointment!",
      text: "You will receive notifications shortly.",
      confirmButtonText: "OK",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(() => {
      window.location.href = "https://yuukke.com/";
    });
  }
};

  const handleAssessmentComplete = (data) => {
    setState((previous) => ({
      ...previous,
      assessmentAnswer: data,
      assessmentForm: false,
      assessmentNeed: false,
      detailsPage: true,
    }));
  };

  const handleBackFromBooking = () => {
    setState((prev) => ({
      ...prev,
      bookingPage: false,
      backThemCard: THEME_CARD_KEYS.includes(String(prev.themeCard)),
      selectedSlot: null,
      slotActiveIndex: null,
      detailsPage: false,
      assessmentForm: false,
      assessmentAnswer: [],
      name: "",
      email: "",
      phoneNumber: "",
      description: "",
    }));
    setShowServiceDropdown(false);
    setScrollPosition(0);
    setCurrentIndex(0);
  };

  const viewChatList = () => {
    if (state.serviceChatDetails) updateState("chatBoxOpen", true);
    else updateState("openServiceChatForm", true);
  };

  const updateServiceFormDetails = (data) => {
    setState((previous) => ({
      ...previous,
      serviceChatDetails: data,
      chatBoxOpen: true,
      openServiceChatForm: false,
    }));
  };

  const userUpcomingMeting = (id) => {
    let filterData = state.userUpcomingMeting.filter((item) => item.bookingId !== id);
    updateState("userUpcomingMeting", filterData);
  };

  const cancelMeeting = (data) => {
    Swal.fire({
      icon: "warning",
      title: data.payedEmail
        ? "Service Cancellation Policy"
        : "Service Cancellation Confirmation",
      text: data.payedEmail
        ? "You are canceling a paid service. Please note that cancellations made within 24 hours of the scheduled service will not be eligible for a refund."
        : "Are you sure you want to cancel the meeting?",
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: data.payedEmail ? "Cancel The Meeting" : "Yes",
      cancelButtonText: data.payedEmail ? "Not Cancel" : "No",
    })
      .then((res) => {
        if (res.value) {
          updateState("loader", true);
          MyYuukke.cancelSlotBooking({ bookingId: data.bookingId })
            .then(() => {
              userUpcomingMeting(data.bookingId);
              Swal.fire({ icon: "success", title: "Meeting Cancelled successfully" }).then(() => updateState("loader", false));
            })
            .catch(() => {
              toast.error("Something went wrong, try later");
              updateState("loader", false);
            });
        }
      });
  };

  const handleResourceClick = (resource) => {
    const identifier = resource?.uuid ?? resource?.resourceUuid ?? resource?.id;
    if (!identifier) {
      toast.error("Something went wrong opening this resource.");
      return;
    }
    props.history.push(`/service-resource/${identifier}`);
  };

  // ─── View selection ───────────────────────────────────────────────────────
  const isQuickBook = !!serviceId && !!state.serviceId && String(state.serviceId) === String(serviceId);

  const activeThemeCard = useMemo(() => {
    if (!state.eventDetails) return null; // wait for data to load
    return THEME_COMPONENTS[state.themeCard] ? state.themeCard : null;
  }, [state.eventDetails, state.themeCard]);

  const ActiveThemeComponent = activeThemeCard !== null ? THEME_COMPONENTS[activeThemeCard] : null;

  const themeCardCommonProps = useMemo(() => ({
      data: state,
      selectService,
      userUpcomingMeting,
      onSendMsgClick: viewChatList,
      uploadDetails,
      updateState,
      confirmDetails,
      recaptcha,
      viewAvailableSlot,
      slugSelected: serviceId,
      handleOpenReviews,
      onResourceClick: handleResourceClick,
    }),
    [state, serviceId],
  );

  return (
    <div className="themesHolder">
      <ServicePageHelmet
        eventDetails={state.eventDetails}
        serviceDetails={state.serviceDetails}
        serviceList={state.serviceList}
        userDetails={state.userDetails}
      />

      {!state.loader && !state.purchaseValid ? (
        <PurchaseInvalidNotice />
      ) : isQuickBook ? (
        <>
          <QuickBookServiceCard
            data={state}
            viewAvailableSlot={viewAvailableSlot}
            updateState={updateState}
            confirmDetails={confirmDetails}
            uploadDetails={uploadDetails}
            recaptcha={recaptcha}
            onBack={() => (window.location.href = `/yuukke-service/${slug}`)}
          />
          <BookingOverlays
            state={state}
            auditUUID={auditUUID}
            updatePaymentStatus={updatePaymentStatus}
            onAssessmentComplete={handleAssessmentComplete}
          />
        </>
      ) : ActiveThemeComponent ? (
        <>
          {React.createElement(ActiveThemeComponent, {
            ...themeCardCommonProps,
            ...(THEME_CARD_WITHOUT_PREVIEW_PROP.has(activeThemeCard)
              ? {}
              : { isPreview: props.isPreview }),
          })}
          <BookingOverlays
            state={state}
            auditUUID={auditUUID}
            updatePaymentStatus={updatePaymentStatus}
            onAssessmentComplete={handleAssessmentComplete}
          />
        </>
      ) : (
        <DefaultThemeProfile
          state={state}
          setState={setState}
          isMobile={isMobile}
          isPreview={props.isPreview}
          primaryColor={primaryColor}
          secondaryColor={secondaryColor}
          toCamelCase={toCamelCase}
          selectService={selectService}
          cancelMeeting={cancelMeeting}
          confirmDetails={confirmDetails}
          uploadDetails={uploadDetails}
          updateState={updateState}
          viewAvailableSlot={viewAvailableSlot}
          recaptcha={recaptcha}
          isHovered={isHovered}
          setIsHovered={setIsHovered}
          setShowServiceDropdown={setShowServiceDropdown}
          showServiceDropdown={showServiceDropdown}
          setScrollPosition={setScrollPosition}
          setCurrentIndex={setCurrentIndex}
          calYear={calYear}
          calMonth={calMonth}
          setCalYear={setCalYear}
          setCalMonth={setCalMonth}
          packageDays={packageDays}
          timeSlots={timeSlots}
          serviceError={serviceError}
          setServiceError={setServiceError}
          handleBackFromBooking={handleBackFromBooking}
          handleResourceClick={handleResourceClick}
          updatePaymentStatus={updatePaymentStatus}
          API_URL={API_URL}
          REACT_APP_SITE_KEY={REACT_APP_SITE_KEY}
          optionsMenu={optionsMenu}
        />
      )}

      {state.openServiceChatForm && (
        <ServiceUserForm
          serviceProviderUserId={state.serviceProviderUserId}
          updateDetails={updateServiceFormDetails}
          closeModel={() => updateState("openServiceChatForm", false)}
        />
      )}
      {state.chatBoxOpen &&
        state.serviceChatDetails &&
        state.serviceProviderUserId && (
          <VcardChatBox
            socket={socket}
            serviceProvider={state.serviceProvider}
            handleChatListBoxClose={() => updateState("chatBoxOpen", false)}
            serviceUser={state.serviceChatDetails}
          />
        )}

      <AllReviewsModal
        open={reviewsModalOpen}
        onClose={() => setReviewsModalOpen(false)}
        reviews={state.reviewList}
        customTheme={state.customTheme}
        primaryColor={primaryColor}
        headingColor={headingColor}
        secondaryColor={secondaryColor}
        secondaryHeadingColor={secondaryHeadingColor}
      />
    </div>
  );
};

export default withTranslation()(withRouter(CalendarVcard));